import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight, ShoppingCart, Check, ChevronDown, ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Video for Back 2 Game product
const BACK2GAME_PRODUCT_ID = '3d42122a-175e-400e-9075-eae44afee648';
const VITAMALE_PRODUCT_ID = '378b7c29-2881-43e1-9ff8-c5642f2c3378';
const BACK2GAME_DEAL_IMAGE = 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/m1ozw06h_%2B%20%281%29.png';
const BACK2GAME_VIDEO_URL = 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/53kuo977_%D7%9E%D7%99%D7%99%D7%A6%D7%92%20%D7%94%D7%97%D7%91%D7%A8%D7%94%2C%20%D7%90%D7%99%D7%9F%20%D7%A6%D7%95%D7%A8%D7%9A%20%D7%91%D7%9E%D7%A8%D7%A9%D7%9D%20%D7%A8%D7%95%D7%A4%D7%90%20%281080%20x%201850%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%282%29.mp4#t=0.5';

// Additional videos for Back 2 Game product
const BACK2GAME_EXTRA_VIDEOS = [
  'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/zje8ijv8_%D7%9C%D7%9C%D7%90%20%D7%A9%D7%9D%20%282160%20x%203841%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.mp4#t=0.5',
  'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/j1df8k2b_%D7%9C%D7%9C%D7%90%20%D7%A9%D7%9D%20%282160%20x%203841%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%282160%20x%203839%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.mp4#t=0.5',
  'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/m316fio7_%D7%A2%D7%99%D7%A6%D7%95%D7%91%20%D7%9C%D7%9C%D7%90%20%D7%A9%D7%9D%20%2810%29.mp4#t=0.5'
];

// Customer reviews for Back 2 Game
const CUSTOMER_REVIEWS = [
  { name: 'יוסי כ.', review: 'מוצר מדהים! הרגשתי שיפור משמעותי כבר אחרי שבועיים של שימוש. ממליץ בחום!', rating: 5 },
  { name: 'אבי מ.', review: 'הזמנתי בספקנות אבל התוצאות מדברות בעד עצמן. האנרגיה שלי עלתה והביצועים השתפרו.', rating: 5 },
  { name: 'דני ל.', review: 'אחרי שניסיתי הרבה מוצרים, סוף סוף מצאתי משהו שעובד. תודה רבה!', rating: 5 },
  { name: 'משה ר.', review: 'המוצר הגיע מהר ובאריזה דיסקרטית. התוצאות פשוט מעולות, ממליץ לכולם.', rating: 5 },
  { name: 'רון ש.', review: 'בן 52 וחשבתי שאין מה לעשות. Back 2 Game החזיר לי את הביטחון העצמי!', rating: 5 },
  { name: 'גיל ב.', review: 'שימוש יומיומי כבר 3 חודשים. השינוי הוא פשוט מטורף. תודה!', rating: 5 },
  { name: 'עמית ד.', review: 'לא האמנתי שזה יעבוד, אבל אחרי חודש אני מרגיש כמו בן 30 שוב.', rating: 5 },
  { name: 'אורי נ.', review: 'המוצר הטוב ביותר שניסיתי. טבעי, בטוח, ועובד מעולה. 5 כוכבים!', rating: 5 },
  { name: 'יעקב ה.', review: 'הרכיבים הטבעיים עשו את ההבדל. מרגיש יותר אנרגטי ובריא מתמיד.', rating: 5 },
  { name: 'שמעון פ.', review: 'הזמנתי פעם שנייה כי המוצר פשוט עובד. שירות מעולה ותוצאות אמיתיות.', rating: 5 },
  { name: 'אלון מ.', review: 'המוצר שינה לי את החיים. אחרי שבועיים הרגשתי שיפור משמעותי באנרגיה ובביצועים.', rating: 5 },
  { name: 'רועי ש.', review: 'מוצר טוב מאוד, לקח כמה ימים עד שהרגשתי את ההשפעה אבל מאז - שיפור ניכר.', rating: 4 },
  { name: 'עומר ג.', review: 'כבר חודשיים שאני משתמש ומרגיש כמו בן 20 מחדש. תודה רבה על המוצר האיכותי!', rating: 5 },
  { name: 'יגאל ר.', review: 'הספריי של Promescent עשה פלאים. בת הזוג שלי שמה לב לשינוי כבר בפעם הראשונה.', rating: 5 },
  { name: 'שמעון ל.', review: 'מוצרים איכותיים במחירים הוגנים. המשלוח הגיע תוך יומיים.', rating: 4 },
  { name: 'נדב ח.', review: 'הפעם הראשונה שהזמנתי מוצר כזה אונליין והופתעתי לטובה. אריזה דיסקרטית ואיכות מעולה.', rating: 5 },
  { name: 'אריאל ב.', review: 'המבצע של 1+1 היה משתלם מאוד. שני המוצרים הגיעו במצב מושלם. ממליץ לכולם!', rating: 5 },
  { name: 'גיא פ.', review: 'השירות היה מצוין, ענו לי בוואטסאפ תוך דקות. המוצר עצמו טוב מאוד.', rating: 4 },
  { name: 'תומר א.', review: 'אחרי שניסיתי מוצרים רבים, זה הדבר היחיד שבאמת עבד. הביטחון העצמי שלי חזר.', rating: 5 },
  { name: 'עידן מ.', review: 'אבקת החלבון באיכות גבוהה מאוד. הטעם מעולה ונספגת מהר.', rating: 5 },
  { name: 'יוני ד.', review: 'הקראטין עושה את העבודה. שיפור בביצועים באימון אחרי שבוע שימוש.', rating: 4 },
  { name: 'מתן ה.', review: 'הזמנתי חבילה של 3 יחידות ובאמת חסכתי. המוצר מגיע עם הוראות ברורות בעברית.', rating: 5 },
  { name: 'אסף ק.', review: 'בהתחלה הייתי סקפטי אבל החלטתי לנסות. אחרי 3 שבועות אני יכול להגיד שזה עובד.', rating: 4 },
  { name: 'ליאור נ.', review: 'חבר המליץ לי והוא צדק. איכות מעולה, משלוח מהיר ותוצאות אמיתיות.', rating: 5 },
  { name: 'בועז צ.', review: 'שירות לקוחות ברמה הכי גבוהה. תשובה מקצועית בוואטסאפ תוך דקות.', rating: 5 },
  { name: 'ירון ז.', review: 'הטיטאן ג\'ל שינה את חווית הזוגיות שלנו. נספג מהר ותחושה מדהימה.', rating: 5 },
  { name: 'עמית ע.', review: 'הפעם השנייה שאני מזמין. כל מוצר שניסיתי מכאן היה מצוין.', rating: 5 },
  { name: 'דור י.', review: 'איסוף עצמי מראשון לציון היה סופר נוח. המוצר הגיע ארוז יפה.', rating: 4 },
  { name: 'איתמר פ.', review: 'הויטמל עזר לי ולאשתי בדרך להריון. אחרי 3 חודשים קיבלנו בשורה משמחת!', rating: 5 },
  { name: 'רם ס.', review: 'לקחתי את החבילה המשולבת - Back 2 Game + ספריי. השילוב עושה פלאים.', rating: 5 },
];

// All formula ingredients for Back 2 Game carousel
const ALL_FORMULA_INGREDIENTS = [
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/zx18523r_5.png',
    title: 'MACA', titleHe: 'מאקה',
    description: 'הידוע בכינוי "ג\'ינסנג הפרואני", המאקה הוא צמח יליד פרו ששימש מאות שנים כדי לתמוך בחשק המיני ולהגביר את רמות האנרגיה.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/khsp85hs_6.png',
    title: 'BIOPERINE', titleHe: 'ביופרין',
    description: 'מופק מפלפל שחור, ביופרין הוא תמצית ידועה ביכולתה לשפר את ספיגת חומרים תזונתיים. זה עוזר לשפר את הזמינות הביולוגית של מרכיבים אחרים, ממקסם את היעילות שלהם.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/knnbwptc_7.png',
    title: 'BORON', titleHe: 'בורון',
    description: 'עשיר בסיבים תזונתיים, תומך בייצור טסטוסטרון טבעי בזכות מינרל הבורון שבו. משפיע על זרימת הדם והסיבולת, מסייע גם לשיפור ביצועים וחשק מיני באופן טבעי.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/d85u53qj_8.png',
    title: 'ZINC PICOLINATE', titleHe: 'אבץ פיקולינט',
    description: 'אבץ הוא מינרל חיוני לתפקודי גוף רבים. אבץ פיקולינט הוא צורה ביולוגית זמינה מאוד של אבץ, המבטיחה ספיגה וניצול מיטביים על ידי הגוף.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/i40rdt0q_9.png',
    title: 'SAW PALMETTO', titleHe: 'דקל ננסי',
    description: 'תמצית דקל ננסי תומכת בבריאות הערמונית ומאזנת את רמות ההורמונים. משמש מאות שנים לתמיכה בבריאות הגבר ושיפור התפקוד המיני.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/qe5vg2gq_11.png',
    title: 'CNIDIUM MONNIERI', titleHe: 'קנידיום',
    description: 'עשב סיני מסורתי זה ידוע בעקרונותיו הפעילים לשיפור זרימת הדם ולתמיכה בבריאות. הוא משמש לעתים קרובות לתמיכה בתפקוד בריא של זיקפה.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/si10bnr1_12.png',
    title: 'KOREAN GINSENG', titleHe: "ג'ינסנג קוריאני",
    description: 'ג\'ינסנג קוראיני הוא צמח מרפא עתיק המשמש לשיפור האנרגיה, הסיבולת והביצועים. הוא תומך במערכת החיסון ומסייע בשיפור התפקוד המיני.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/0uu2cr11_13.png',
    title: 'VITAMIN D3', titleHe: 'ויטמין D3',
    description: 'המכונה "ויטמין השמש", ויטמין D3 תומך בתפקודי גוף חיוניים, כולל ייצור טסטוסטרון. זה חיוני לשמירה על הבריאות והרווחה הכללית.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/m3g2ha9f_14.png',
    title: 'VITAMIN E', titleHe: 'ויטמין E',
    description: 'כנוגד חמצון רב עוצמה, ויטמין E מסייע בהגנה על התאים מפני מתח חמצוני. זה גם תומך בזרימת דם בריאה, מה שתורם לבריאות המינית.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/foanu89h_15.png',
    title: 'TRIBULUS', titleHe: 'טריבולוס',
    description: 'טריבולוס הוא צמח מרפא המשמש לתמיכה בייצור טסטוסטרון טבעי, שיפור הליבידו והגברת הכוח והסיבולת הגופנית.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/7tqo6pqn_10.png',
    title: 'L-ARGININE', titleHe: "ל-ארג'ינין",
    description: 'חומצת אמינו, L-Arginine היא מבשר לחנקן תחמוצת, מולקולה המסייעת בהרחבת כלי דם כדי לשפר זרימת הדם. משמש לעתים קרובות לתמיכה בתפקוד זיקפה ושיפור ביצועי האימון.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/q376yi78_1.png',
    title: 'DAMIANA', titleHe: 'דמיאנה',
    description: 'ילידת אמריקה המרכזית והדרומית, דמיאנה יש היסטוריה ארוכה של שימוש כמגביר אפרודיזיאק וליבידו. מאמינים שהיא מגבירה את החשק המיני ומשפרת את הרווחה הכללית.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/1y308dl7_2.png',
    title: 'EPIMEDIUM', titleHe: 'אפימדיום',
    description: 'אפימדיום, הידוע גם כ"עשב העז השובבה", הוא צמח מרפא סיני המשמש לשיפור התפקוד המיני, הגברת הליבידו ותמיכה בזרימת דם בריאה.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/i4tldrje_3.png',
    title: 'ASHWAGANDHA', titleHe: 'אשוואגנדה',
    description: 'אשוואגנדה היא צמח אדפטוגני עתיק המסייע בהפחתת מתח, שיפור האנרגיה והסיבולת, ותמיכה בייצור טסטוסטרון טבעי ובריאות המיניות.'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/xn9rkbb2_6.png',
    title: 'GINKGO BILOBA', titleHe: 'גינקו בילובה',
    description: 'מופק מעלי עץ הגינקו, גינקו בילובה הוא עשב עתיק המסייע בזרימת הדם, תומך בתפקוד קוגניטיבי, ומסייע במאבק בעייפות ושיפור הביצועים הפיזיים.'
  }
];

const PROMESCENT_PRODUCT_ID = '2aa24bcd-956c-491c-a2a5-451f89e9968a';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Redirect Promescent to its dedicated page
  useEffect(() => {
    if (id === PROMESCENT_PRODUCT_ID) {
      navigate('/promescent', { replace: true });
    }
  }, [id, navigate]);
  
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentReview, setCurrentReview] = useState(0);
  const [currentIngredient, setCurrentIngredient] = useState(0);
  const { addToCart } = useCart();
  
  // Scroll to hash anchor (e.g. #ingredients) after page loads
  useEffect(() => {
    if (!loading && product && window.location.hash) {
      const scrollToHash = () => {
        const el = document.querySelector(window.location.hash);
        if (el) {
          const yOffset = -80;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      };
      // Multiple attempts to ensure content is rendered
      setTimeout(scrollToHash, 300);
      setTimeout(scrollToHash, 1000);
      setTimeout(scrollToHash, 2000);
    }
  }, [loading, product]);
  
  // Auto-rotate reviews every 6 seconds
  const nextReview = useCallback(() => {
    setCurrentReview((prev) => (prev + 1) % CUSTOMER_REVIEWS.length);
  }, []);
  
  const prevReview = useCallback(() => {
    setCurrentReview((prev) => (prev - 1 + CUSTOMER_REVIEWS.length) % CUSTOMER_REVIEWS.length);
  }, []);
  
  // Ingredients carousel navigation
  const nextIngredient = useCallback(() => {
    const step = window.innerWidth >= 1024 ? 3 : 1;
    setCurrentIngredient((prev) => (prev + step) % ALL_FORMULA_INGREDIENTS.length);
  }, []);
  
  const prevIngredient = useCallback(() => {
    const step = window.innerWidth >= 1024 ? 3 : 1;
    setCurrentIngredient((prev) => (prev - step + ALL_FORMULA_INGREDIENTS.length) % ALL_FORMULA_INGREDIENTS.length);
  }, []);
  
  useEffect(() => {
    if (id === BACK2GAME_PRODUCT_ID) {
      const reviewInterval = setInterval(nextReview, 6000);
      return () => {
        clearInterval(reviewInterval);
      };
    }
  }, [id, nextReview]);
  
  useEffect(() => {
    fetchProduct();
  }, [id]);
  
  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${API}/products/${id}`);
      setProduct(response.data);
    } catch (error) {
      console.error('Error fetching product:', error);
      toast.error('שגיאה בטעינת המוצר');
    } finally {
      setLoading(false);
    }
  };
  
  // Cart sound effect
  const playCartSound = () => {
    const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
    audio.volume = 0.3;
    audio.play().catch(() => {});
  };

  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [showCartPopup, setShowCartPopup] = useState(false);
  
  const handleAddToCart = () => {
    if (isAddedToCart) {
      navigate('/cart');
    } else {
      addToCart(product);
      playCartSound();
      setIsAddedToCart(true);
      setShowCartPopup(true);
      setTimeout(() => setShowCartPopup(false), 2000);
    }
  };
  
  if (loading) {
    return (
      <div className="container py-16" data-testid="product-detail-loading">
        <div className="text-center">
          <p className="text-xl text-stone-600">טוען מוצר...</p>
        </div>
      </div>
    );
  }
  
  if (!product) {
    return (
      <div className="container py-16" data-testid="product-not-found">
        <div className="text-center">
          <p className="text-xl text-stone-600 mb-8">המוצר לא נמצא</p>
          <button
            onClick={() => navigate('/products')}
            className="h-12 px-8 rounded-full bg-[#D97706] text-white font-bold hover:shadow-lg transition-all duration-300"
            style={{ fontFamily: 'Heebo, sans-serif' }}
          >
            חזור למוצרים
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container py-16" data-testid="product-detail-page">
      {/* Cart Popup - slides from top */}
      {showCartPopup && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-slide-down" data-testid="cart-popup">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}
      
      {/* Back Button */}
      <button
        onClick={() => navigate('/products')}
        data-testid="back-to-products"
        className="flex items-center gap-2 text-stone-600 hover:text-[#D97706] mb-4 transition-colors"
      >
        <ArrowRight className="w-5 h-5" />
        <span>חזור למוצרים</span>
      </button>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Product Video (for Back 2 Game) and Image */}
        <div className="space-y-4">
          {/* Video - only shown for Back 2 Game product */}
          {id === BACK2GAME_PRODUCT_ID && (
            <>
            <div className="rounded-2xl overflow-hidden bg-stone-100" data-testid="product-video">
              <video
                src={BACK2GAME_VIDEO_URL}
                controls
                playsInline
                preload="auto"
                poster={product?.image}
                className="w-full h-auto max-h-[500px] object-cover"
                style={{ aspectRatio: '9/16' }}
              >
                הדפדפן שלך לא תומך בתגית וידאו.
              </video>
            </div>
            <div className="flex justify-center mt-4" data-testid="certifications-badge">
              <img src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/j4hgobtl_%2B%20%284%29.png" alt="אישור GMP משרד הבריאות ובד״צ מהדרין" className="max-w-[400px] w-full h-auto" />
            </div>
            </>
          )}
          
          {/* Product Image - regular products only (not Back 2 Game) */}
          {id !== BACK2GAME_PRODUCT_ID && (
            <div className="rounded-2xl overflow-hidden bg-white" data-testid="product-image">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-auto object-contain"
              />
            </div>
          )}
        </div>
        
        {/* Product Info */}
        <div className="space-y-6" data-testid="product-info">
          <div>
            <span className="inline-block text-sm font-semibold text-[#D97706] bg-[#D97706]/10 px-4 py-2 rounded-full mb-4">
              {product.category}
            </span>
            <h1 className="text-3xl md:text-4xl font-bold text-[#2C3E2D] mb-0 leading-tight" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="product-title">
              {product.name?.includes(' - ') ? (
                <>
                  <span className="block"><bdi>{product.name.split(' - ')[0]}</bdi></span>
                  <span className="block text-2xl md:text-3xl text-[#D97706]"><bdi>{product.name.split(' - ')[1]}</bdi></span>
                </>
              ) : <bdi>{product.name}</bdi>}
            </h1>
            {/* Subtitle for Back 2 Game - 180 tablets */}
            {product.subtitle && (
              <p className="text-xl text-stone-600 mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {product.subtitle}
              </p>
            )}
            {/* Gift text */}
            {product.gift_text && (
              <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full inline-block mb-4">
                <span className="font-semibold">🎁 {product.gift_text}</span>
              </div>
            )}
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-4xl font-bold text-[#D97706]" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="product-price">
                סה"כ ₪{product.price.toFixed(2)}
              </span>
            </div>
          </div>
          
          <div className="border-t border-stone-200 pt-6">
            <h2 className="text-2xl font-semibold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              תיאור המוצר
            </h2>
            <div className="text-stone-600 leading-relaxed text-lg space-y-3">
              {product.id === BACK2GAME_PRODUCT_ID ? (
                <>
                  <p>פורמולה ייחודית והמתקדמת בעולם, בעלת המינון הכפול כ- 1000 מ"ג חומר פעיל לטבליה אחת!</p>
                  <p>הפורמולה עשויה מצמחים ויטמינים ומינרלים בלבד - כל רכיב נבחר בקפידה רבה.</p>
                  <p>הצמחים עברו עשרות מחקרים והוכחו כיעילים בכל נושא שיפור הגברא.</p>
                  <p>זהו המוצר הטוב ביותר שמכרנו עד היום, עם הרבה לקוחות מרוצים.</p>
                </>
              ) : product.id === VITAMALE_PRODUCT_ID ? (
                <>
                  <p className="font-semibold text-[#2C3E2D]">הפורמולה הייחודית של דוקטור גירש, אמבריולוג קליני בכיר</p>
                  <p>תוסף תזונתי המסייע בשיפור איכות הזרע. הפורמולה של Vitamale מורכבת מויטמינים, מינרלים וחומצות אמינו הכרחיים לתפקוד מיטבי של מערכת הרבייה הזכרית.</p>
                  <p>המוצר נוסה והוכח כיעיל במספר מחקרים מדעיים. פרי פיתוחה של אלנת פריון (ישראל).</p>
                  <p>מיוצר בפיקוח משרד הבריאות, תחת תנאי GMP ותנאי ISO 9001:2000.</p>
                </>
              ) : (
                <p>{product.description}</p>
              )}
            </div>
          </div>
          
          {/* Features + 1+1 Deal Image side by side */}
          {id === BACK2GAME_PRODUCT_ID ? (
            <div className="grid grid-cols-2 gap-4 items-start">
              {/* 1+1 Deal Image - Left side */}
              <div data-testid="product-image">
                <div className="rounded-2xl overflow-hidden bg-white">
                  <img
                    src={BACK2GAME_DEAL_IMAGE}
                    alt="מבצע 1+1"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-gradient-to-r from-[#D97706] via-[#F59E0B] to-[#D97706] py-3 px-4 rounded-b-2xl" data-testid="deal-text-below-image">
                  <p className="text-center text-lg font-black text-white" style={{ fontFamily: 'Heebo, sans-serif', textShadow: '1px 1px 3px rgba(0,0,0,0.3)' }}>
                    רכוש 1 קבל 1 מתנה!
                  </p>
                </div>
              </div>
              {/* Features - Right side */}
              <div className="bg-[#F5F5F4] rounded-2xl p-4">
                <h3 className="text-lg font-semibold text-[#2C3E2D] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  יתרונות המוצר
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                    <span className="text-sm text-stone-600">זקפה חזקה יותר לאורך זמן</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                    <span className="text-sm text-stone-600">חיזוק רמת הטסטוסטרון</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                    <span className="text-sm text-stone-600">חיזוק האנרגיה המינית</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                    <span className="text-sm text-stone-600">זרימת דם יעילה יותר</span>
                  </li>
                </ul>
              </div>
            </div>
          ) : id === VITAMALE_PRODUCT_ID ? (
            <div className="bg-[#F5F5F4] rounded-2xl p-6">
              <h3 className="text-xl font-semibold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
                יתרונות המוצר
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">שיפור איכות הזרע ותנועתיות תאי הזרע</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">חיזוק מערכת הרבייה הזכרית</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">הגנה על החומר הגנטי של תאי הזרע</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">פעילות תקינה של בלוטת הערמונית ויותרת האשך</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">הוכח כיעיל במספר מחקרים מדעיים</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">היעיל ביותר - מעל 20 שנה בשוק</span>
                </li>
              </ul>
            </div>
          ) : (
            <div className="bg-[#F5F5F4] rounded-2xl p-6">
              <h3 className="text-xl font-semibold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
                יתרונות המוצר
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">זקפה חזקה יותר לאורך זמן</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">חיזוק רמת הטסטוסטרון</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">חיזוק האנרגיה המינית</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-0.5" />
                  <span className="text-stone-600">זרימת דם יעילה יותר</span>
                </li>
              </ul>
            </div>
          )}
          
          {/* Add to Cart */}
          <div className="flex gap-4">
            <button
              onClick={handleAddToCart}
              disabled={!product.in_stock}
              data-testid="add-to-cart-detail"
              className={`flex-1 h-14 rounded-full font-bold hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${
                isAddedToCart 
                  ? 'bg-green-500 text-white hover:bg-green-600' 
                  : 'bg-[#D97706] text-white hover:bg-[#B45309]'
              }`}
              style={{ fontFamily: 'Heebo, sans-serif' }}
            >
              <ShoppingCart className="w-5 h-5" />
              {!product.in_stock ? 'אזל מהמלאי' : isAddedToCart ? 'מעבר לרכישה' : 'הוסף לסל'}
            </button>
          </div>
          
          {!product.in_stock && (
            <p className="text-center text-stone-500 text-sm">
              המוצר יחזור למלאי בקרוב
            </p>
          )}
        </div>
      </div>

      {/* === FULL WIDTH SECTIONS (outside the 2-col grid) === */}

      {/* Vitamale Sections */}
      {id === VITAMALE_PRODUCT_ID && (
        <>
          {/* How to Use / Dosage */}
          <div className="mt-12 bg-blue-50 rounded-2xl p-8" data-testid="vitamale-dosage">
            <h3 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-6 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
              מינון מומלץ ואופן שימוש
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="text-center bg-white rounded-xl p-6 shadow-sm">
                <div className="w-14 h-14 rounded-full bg-blue-500 text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">1</div>
                <h4 className="font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>מינון יומי</h4>
                <p className="text-stone-600 text-sm">2 כמוסות, 3 פעמים ביום לאחר ארוחה</p>
              </div>
              <div className="text-center bg-white rounded-xl p-6 shadow-sm">
                <div className="w-14 h-14 rounded-full bg-blue-500 text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">2</div>
                <h4 className="font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>משך הטיפול</h4>
                <p className="text-stone-600 text-sm">למשך 3 חודשים לפחות (מומלץ 3-6 חודשים). תהליך ייצור הזרע לוקח כ-3 חודשים</p>
              </div>
              <div className="text-center bg-white rounded-xl p-6 shadow-sm">
                <div className="w-14 h-14 rounded-full bg-blue-500 text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">3</div>
                <h4 className="font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>המלצה</h4>
                <p className="text-stone-600 text-sm">מומלץ להזמין 3 חבילות לתקופה של 3 חודשים. להמשיך כל עוד לא הושג הריון</p>
              </div>
            </div>
          </div>

          {/* Ingredients Breakdown */}
          <div className="mt-12" data-testid="vitamale-ingredients">
            <h3 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-6 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
              ויטמינים, מינרלים וחומצות אמינו
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
              {[
                { name: 'ויטמין A', desc: 'תפקיד במבנה ובתפקוד רקמות האפיתל של מערכת הרבייה' },
                { name: 'ויטמין B6', desc: 'חיוני בפעילות של חומצות אמינו ומסייע לפעילות החומצה הפולית' },
                { name: 'ויטמין B12', desc: 'הכרחי לייצור תקין של ה-DNA, מעורב בפעילות החומצה הפולית' },
                { name: 'ויטמין C', desc: 'אנטיאוקסידנט - מונע חמצון ומגן מזיהומים' },
                { name: 'ויטמין E', desc: 'חיוני למבנה תקין של התא ולהאטת תהליך ההזדקנות' },
                { name: 'ויטמין D', desc: 'מעורב בהתפתחות התקינה של תאי הזרע' },
                { name: 'חומצה פולית', desc: 'חיונית בייצור החומר הגנטי (ביחד עם B6 ו-B12)' },
                { name: 'סלניום', desc: 'שומר על חיוניות ממברנת התא, מסייע לתנועתיות תאי הזרע' },
                { name: 'אבץ', desc: 'מעורב בחילוף החומרים, חלוקת תאים ומבנה החומר הגנטי' },
                { name: 'מגנזיום', desc: 'חיוני לפעילות בלוטת הערמונית' },
                { name: 'ארגינין', desc: 'נחוץ לתנועתיות תאי הזרע ולפעילות יותרת האשך' },
                { name: 'ציסטאין', desc: 'מגן על החומר הגנטי של תאי הזרע בשיתוף עם האבץ' },
                { name: 'קרניטין', desc: 'חיוני לתפקוד יותרת האשך, מסייע להבשלה ותנועתיות הזרע' },
                { name: 'קואנזים Q10', desc: 'מונע חמצון חזק, חלק ממערכת ייצור האנרגיה בתא הזרע' },
              ].map((ing, i) => (
                <div key={i} className="bg-white rounded-xl p-4 border border-stone-200 shadow-sm">
                  <h4 className="font-bold text-[#2C3E2D] mb-1 text-base" style={{ fontFamily: 'Heebo, sans-serif' }}>{ing.name}</h4>
                  <p className="text-stone-500 text-sm leading-relaxed">{ing.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* What makes Vitamale unique */}
          <div className="mt-12 bg-green-50 rounded-2xl p-8" data-testid="vitamale-unique">
            <h3 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-4 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
              במה Vitamale ייחודי?
            </h3>
            <div className="max-w-3xl mx-auto space-y-4 text-stone-600 text-lg leading-relaxed">
              <p>הפורמולה מכילה ריכוז גבוה של מרכיביה ויחס מתאים ביניהם. המוצר הוכח כיעיל במספר מחקרים קליניים ועזר לעשרות אנשים.</p>
              <p>התוסף Vitamale מיוצר בפיקוח משרד הבריאות, תחת תנאי GMP (Good Manufacture Production) ותחת תנאי ISO 9001:2000.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 max-w-3xl mx-auto">
              <div className="bg-white rounded-xl p-4 text-center border border-green-200">
                <p className="font-bold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>פיקוח משרד הבריאות</p>
              </div>
              <div className="bg-white rounded-xl p-4 text-center border border-green-200">
                <p className="font-bold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>תנאי GMP</p>
              </div>
              <div className="bg-white rounded-xl p-4 text-center border border-green-200">
                <p className="font-bold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>ISO 9001:2000</p>
              </div>
            </div>
          </div>

          {/* Scientific References */}
          <div className="mt-12" data-testid="vitamale-references">
            <details className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
              <summary className="p-6 cursor-pointer font-semibold text-xl text-[#2C3E2D] hover:bg-stone-50 transition-colors flex items-center gap-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                <ChevronDown className="w-5 h-5" />
                מאמרים מדעיים התומכים בפעילות ה-Vitamale
              </summary>
              <div className="p-6 pt-0 space-y-2 text-sm text-stone-500" dir="ltr">
                <p>Comhaire et al., 2000. The effects of combined conventional treatment, oral antioxidants and essential fatty acids on sperm biology in subfertile men. Prostaglaglandins Leukot Essent Fatty Acids 63 (3): 159-165</p>
                <p>Hsu and Guo, 2002. Antioxidant nutrients and lead toxicity. Toxicology 180: 33-44</p>
                <p>Wong et al., 2002. Effects of folic acid and zinc sulfate on male factor subfertility: a double-blind, randomized, placebo controlled trial. Fertil. Steril. 77: 491-498</p>
                <p>Greco et al., 2005. ICSI in cases of sperm DNA damage: beneficial effect of oral antioxidant treatment. Hum. Reprod. 20 (9): 2590-2594</p>
                <p>Agarwal et al., 2006. The role of free radicals and antioxidants in reproduction. Curr. Opin. Obstet. Gynecol. 18: 325-332</p>
                <p>Young et al., 2008. The association of folate, zinc and antioxidant intake with sperm aneuploidy in healthy non-smoking men. Hum. Reprod. 22(5): 1014-1022</p>
              </div>
            </details>
          </div>
        </>
      )}

      {/* Extra Videos Section - Full Width */}
      {id === BACK2GAME_PRODUCT_ID && (
        <div className="mt-12" data-testid="extra-videos-section">
          <h3 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-6 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
            נלקח מחוות דעת אמיתיות
          </h3>
          <div className="grid grid-cols-3 gap-6">
            {BACK2GAME_EXTRA_VIDEOS.map((videoUrl, index) => (
              <div key={index} className="rounded-2xl overflow-hidden bg-stone-100" data-testid={`extra-video-${index}`}>
                <video
                  src={videoUrl}
                  controls
                  playsInline
                  preload="auto"
                  poster={product?.image}
                  className="w-full h-auto object-cover mx-auto"
                  style={{ aspectRatio: '9/16', maxHeight: '400px' }}
                >
                  הדפדפן שלך לא תומך בתגית וידאו.
                </video>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Formula Ingredients Carousel - Full Width */}
      {id === BACK2GAME_PRODUCT_ID && (
        <div className="mt-12" id="ingredients" data-testid="formula-ingredients-section">
          <h3 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-6 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
            רכיבי הפורמולה
          </h3>
          
          <div className="relative">
            <button
              onClick={prevIngredient}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-[#D97706] rounded-full shadow-lg flex items-center justify-center hover:bg-[#b86305] transition-colors"
              data-testid="ingredient-prev"
            >
              <ChevronLeft className="w-6 h-6 text-white" />
            </button>
            
            <div className="mx-12">
              {/* Mobile - single card */}
              <div className="lg:hidden">
                <div className="bg-gradient-to-b from-white to-stone-50 rounded-2xl overflow-hidden border-2 border-[#D97706] shadow-lg" data-testid="ingredient-card">
                  <div className="bg-white p-4">
                    {ALL_FORMULA_INGREDIENTS[currentIngredient].title && (
                      <div className="text-center mb-2">
                        <p className="font-black text-lg text-[#2C3E2D] tracking-wide">{ALL_FORMULA_INGREDIENTS[currentIngredient].title}</p>
                        <p className="text-sm font-bold text-[#D97706]">{ALL_FORMULA_INGREDIENTS[currentIngredient].titleHe}</p>
                      </div>
                    )}
                    <div className="flex justify-center">
                      <img src={ALL_FORMULA_INGREDIENTS[currentIngredient].image} alt={ALL_FORMULA_INGREDIENTS[currentIngredient].title || 'רכיב'} className="w-full max-w-[280px] h-auto rounded-xl shadow-md" />
                    </div>
                  </div>
                  <div className="bg-[#2C3E2D] p-4 relative">
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 bg-[#2C3E2D] rotate-45"></div>
                    <p className="text-white text-sm leading-relaxed text-center relative z-10" style={{ fontFamily: 'Heebo, sans-serif' }}>
                      {ALL_FORMULA_INGREDIENTS[currentIngredient].description}
                    </p>
                  </div>
                </div>
              </div>

              {/* Desktop - 3 cards full width */}
              <div className="hidden lg:grid lg:grid-cols-3 gap-6">
                {[0, 1, 2].map((offset) => {
                  const idx = (currentIngredient + offset) % ALL_FORMULA_INGREDIENTS.length;
                  const ingredient = ALL_FORMULA_INGREDIENTS[idx];
                  return (
                    <div key={idx} className="bg-[#2C3E2D] rounded-2xl overflow-hidden border-2 border-[#D97706] shadow-lg flex flex-col" data-testid={`ingredient-card-${offset}`}>
                      <div className="bg-white p-4">
                        {ingredient.title && (
                          <div className="text-center mb-2">
                            <p className="font-black text-lg text-[#2C3E2D] tracking-wide">{ingredient.title}</p>
                            <p className="text-sm font-bold text-[#D97706]">{ingredient.titleHe}</p>
                          </div>
                        )}
                        <div className="flex justify-center">
                          <img src={ingredient.image} alt={ingredient.title || 'רכיב'} className="w-full max-w-[220px] h-auto rounded-xl shadow-md" />
                        </div>
                      </div>
                      <div className="bg-[#2C3E2D] p-4 relative flex-1 flex items-center">
                        <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-5 h-5 bg-[#2C3E2D] rotate-45"></div>
                        <p className="text-white text-sm leading-relaxed text-center relative z-10 w-full" style={{ fontFamily: 'Heebo, sans-serif' }}>
                          {ingredient.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              <div className="py-4">
                <div className="flex justify-center gap-1.5 flex-wrap max-w-[220px] mx-auto">
                  {ALL_FORMULA_INGREDIENTS.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentIngredient(index)}
                      className={`w-2.5 h-2.5 rounded-full transition-all ${
                        index === currentIngredient ? 'bg-[#D97706] scale-125' : 'bg-stone-300 hover:bg-stone-400'
                      }`}
                      data-testid={`ingredient-dot-${index}`}
                    />
                  ))}
                </div>
                <p className="text-center text-[#2C3E2D] font-semibold text-sm mt-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  רכיב {currentIngredient + 1} מתוך {ALL_FORMULA_INGREDIENTS.length}
                </p>
              </div>
            </div>
            
            <button
              onClick={nextIngredient}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-[#D97706] rounded-full shadow-lg flex items-center justify-center hover:bg-[#b86305] transition-colors"
              data-testid="ingredient-next"
            >
              <ChevronRight className="w-6 h-6 text-white" />
            </button>
          </div>
        </div>
      )}

      {/* Customer Reviews Carousel - Full Width */}
      {id === BACK2GAME_PRODUCT_ID && (
        <div className="mt-12" data-testid="reviews-carousel">
          <h3 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-6 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
            מה הלקוחות אומרים
          </h3>
          
          <div className="relative max-w-2xl mx-auto">
            <button
              onClick={prevReview}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 transition-colors"
              data-testid="review-prev"
            >
              <ChevronLeft className="w-6 h-6 text-[#2C3E2D]" />
            </button>
            
            <div className="mx-12 bg-white rounded-2xl p-6 border border-stone-200 shadow-sm" data-testid="review-card">
              <div className="flex justify-center gap-1 mb-3">
                {[...Array(CUSTOMER_REVIEWS[currentReview].rating || 5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#D97706] text-[#D97706]" />
                ))}
                {[...Array(5 - (CUSTOMER_REVIEWS[currentReview].rating || 5))].map((_, i) => (
                  <Star key={`e-${i}`} className="w-5 h-5 text-stone-300" />
                ))}
              </div>
              <p className="text-stone-600 text-center mb-4 min-h-[60px]" style={{ fontFamily: 'Heebo, sans-serif' }}>
                "{CUSTOMER_REVIEWS[currentReview].review}"
              </p>
              <p className="text-[#2C3E2D] font-semibold text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
                - {CUSTOMER_REVIEWS[currentReview].name}
              </p>
              <div className="flex justify-center gap-2 mt-4">
                {CUSTOMER_REVIEWS.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentReview(index)}
                    className={`w-2 h-2 rounded-full transition-colors ${
                      index === currentReview ? 'bg-[#D97706]' : 'bg-stone-300'
                    }`}
                    data-testid={`review-dot-${index}`}
                  />
                ))}
              </div>
            </div>
            
            <button
              onClick={nextReview}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 transition-colors"
              data-testid="review-next"
            >
              <ChevronRight className="w-6 h-6 text-[#2C3E2D]" />
            </button>
          </div>
        </div>
      )}
      
      {/* Additional Info */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl p-6 border border-stone-100 text-center">
          <div className="text-3xl mb-2">🚚</div>
          <h3 className="font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
            משלוחים מהירים
          </h3>
          <p className="text-sm text-stone-600">לנקודות איסוף או בית הלקוח</p>
        </div>
        
        <div className="bg-white rounded-2xl p-6 border border-stone-100 text-center">
          <div className="text-3xl mb-2">🔒</div>
          <h3 className="font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
            תשלום מאובטח
          </h3>
          <p className="text-sm text-stone-600">מערכת תשלום מוצפנת ובטוחה</p>
        </div>
        
        <div className="bg-white rounded-2xl p-6 border border-stone-100 text-center">
          <div className="text-3xl mb-2">📦</div>
          <h3 className="font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
            אריזה דיסקרטית
          </h3>
          <p className="text-sm text-stone-600">שמירה מלאה על פרטיות</p>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;